import { talentApi } from 'yxt-biz-pc/packages/api';
export const SkillSortList = (data, params) => {
  return talentApi.post('client/skills/list', data, { params: params });
};
